module.exports = {"tags":"Category","category":"Loyalty Category","outlet":"Station"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/dashboard.php
// module id = SaQV
// module chunks = 86